import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MunilyAvatarObjectFit, MunilyAvatarSize, MUNILY_AVATAR_DEFAULTS } from './avatar.types';

@Component({
  selector: 'common-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarComponent implements OnChanges {
  @Input() imageUrl: string | undefined = undefined;
  @Input() initials: string = MUNILY_AVATAR_DEFAULTS.initials;
  @Input() size: MunilyAvatarSize = MUNILY_AVATAR_DEFAULTS.size;
  @Input() objectFit: MunilyAvatarObjectFit = MUNILY_AVATAR_DEFAULTS.objectFit;
  @Input() backgroundColor: string = MUNILY_AVATAR_DEFAULTS.backgroundColor;
  @Input() alt: string = MUNILY_AVATAR_DEFAULTS.alt;

  public avatarClasses: string[] = [];

  constructor() {
    this.syncAvatarClasses();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['size']) {
      this.syncAvatarClasses();
    }
  }

  get displayInitials(): string {
    return this.initials.slice(0, 2).toUpperCase();
  }

  private syncAvatarClasses(): void {
    const next: string[] = [];
    if (this.size === 'small') next.push('munily-avatar--small');
    if (this.size === 'medium') next.push('munily-avatar--medium');
    if (this.size === 'large') next.push('munily-avatar--large');
    this.avatarClasses = next;
  }
}
